import {
  faArrowRight,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import Button from "../../Component/Input/Button";
import { LOCALE } from "../../Hook/locale";
import id from "./assets/id.png";
import mail from "./assets/mail.png";
import sign from "./assets/sign.png";
import yoti from "./assets/yoti.png";
import ReactSimplyCarousel from 'react-simply-carousel';
import { useState } from "react";
import useIsMobile from "../../Hook/mobile";

const inside = [
  <div className="flex flex-col  w-[calc(100vw-4rem)] lg:w-auto  h-full gap-2 rounded-xl bg-[#470841] p-4 pb-12">
    <div className="text-center bg-[#00000033] w-fit mx-auto px-4 py-2 rounded-full mb-2">
      <FormattedMessage id="content_provider__step_1" />
    </div>
    <div className="flex h-32 justify-center">
      <div>
        <img src={id} alt="" className="max-w-[8rem]" />
      </div>
    </div>
    <div className="text-[#09C55D]">
      <FormattedMessage id="content_provider__step_1_title" />
    </div>
    <div className="h-10">
      <div className="p-2 bg-[#00000033] w-fit rounded-md flex items-center gap-2">
        <FormattedMessage id="content_provider__with" />
        <img className="h-8" src={yoti} />
      </div>
    </div>
    <div className="pt-10">
      <FormattedMessage id="content_provider__step_1_description" />
    </div>
  </div>,
  <div className="flex flex-col  w-[calc(100vw-4rem)] lg:w-auto  h-full gap-2 rounded-xl bg-[#2D2205] p-4">
    <div className="text-center bg-[#00000033] w-fit mx-auto px-4 py-2 rounded-full mb-2">
      <FormattedMessage id="content_provider__step_2" />
    </div>
    <div className="flex h-32 justify-center">
      <div>
        <img src={mail} alt="" className="max-w-[8rem]" />
      </div>
    </div>
    <div className="text-[#09C55D]">
      <FormattedMessage id="content_provider__step_2_title" />
    </div>
    <div className="pt-10">
      <FormattedMessage id="content_provider__step_2_description" />
    </div>
  </div>,
  <div className="flex flex-col  w-[calc(100vw-4rem)] lg:w-auto  h-full gap-2 rounded-xl bg-[#2F2B81] p-4">
    <div className="text-center bg-[#00000033] w-fit mx-auto px-4 py-2 rounded-full mb-2">
      <FormattedMessage id="content_provider__step_3" />
    </div>
    <div className="flex h-32 justify-center">
      <div>
        <img src={sign} alt="" className="max-w-[8rem]" />
      </div>
    </div>
    <div className="text-[#09C55D]">
      <FormattedMessage id="content_provider__step_3_title" />
    </div>
    <div className="h-10">
      <div className="p-2 bg-[#00000033] w-fit rounded-md flex items-center gap-2">
        <FormattedMessage id="content_provider__with" />
        <div className="w-24">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178 40" version="1.1">
            <g id="SA_2.-View-empty-doc" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-271.000000, -175.000000)">
              <g id="Header-bar" transform="translate(0.000000, 160.000000)">
                <g id="sign_lockup_logo_40px" transform="translate(271.000000, 15.000000)">
                  <rect id="Rectangle-6" fill="#FFFFFF" x="101" y="3" width="74" height="34" />
                  <g id="yoti_logo">
                    <polygon id="Path" fill="#333B40" points="89 40 0 40 0 0 89 0" />
                    <polygon id="Shape" fill="#BFC2C4" points="40 4 4 4 4 36 40 36" />
                    <polygon id="Shape" fill="#2D9FFF" points="40 36 85 36 85 4 40 4" />
                    <circle id="Oval-91" fill="#333B40" cx="40.0000029" cy="20.0000029" r="10.1999998" />
                    <circle id="Oval-268" fill="#FFFFFF" cx="40.0000029" cy="20.0000029" r="6.19999981" />
                    <rect id="Rectangle-318" fill="#333B40" x="38" y="2" width="4" height="11" />
                    <rect id="Rectangle-318-Copy" fill="#333B40" x="38" y="28" width="4" height="9" />
                    <polygon id="Path" fill="#333B40" points="28.5942867 12.6666666 25.7903226 9.58064516 19.1774194 16.1935484 12.7832376 9.58064516 9.67875144 12.6666666 17 20 17 30 21 30 21 20" />
                    <polygon id="Path" fill="#333B40" points="70 14 63 14 63 30 59 30 59 14 52 14 52 10 70 10" />
                    <polygon id="Path" fill="#333B40" points="73 10 73 30 77 30 77 10" />
                  </g>
                  <rect id="Rectangle" fill="#333B40" x="89" y="18" width="9" height="4" />
                  <path d="M102,4 L102,36 L174,36 L174,4 L102,4 Z M98,0 L178,0 L178,40 L98,40 L98,0 Z" id="Rectangle-5" fill="#333B40" fill-rule="nonzero" />
                  <path d="M115.888,28.322 C119.361,28.322 121.339,26.62 121.339,23.538 C121.339,22.089 120.764,20.893 119.43,19.628 L117.222,17.581 C116.302,16.707 116.049,16.385 116.049,15.902 C116.049,15.35 116.44,15.028 117.245,15.028 C118.257,15.028 119.614,15.534 120.787,16.339 L122.742,13.234 C120.902,12.13 119.016,11.555 117.222,11.555 C114.14,11.555 112.231,13.257 112.231,15.971 C112.231,17.489 112.852,18.685 114.278,20.019 L116.371,21.974 C117.176,22.733 117.429,23.147 117.429,23.676 C117.429,24.412 116.854,24.849 115.842,24.849 C114.669,24.849 113.151,24.159 111.656,22.986 L109.517,25.93 C111.495,27.54 113.519,28.322 115.888,28.322 Z M122.966,28 L126.531,28 L129.659,11.9 L126.094,11.9 L122.966,28 Z M139.336,18.685 L138.646,21.882 L142.97,21.882 C142.556,23.676 141.13,24.78 138.922,24.78 C136.139,24.78 134.46,23.239 134.46,20.64 C134.46,17.466 136.76,15.12 140.095,15.12 C141.728,15.12 143.154,15.672 144.442,16.684 L146.765,13.694 C145.132,12.314 142.832,11.555 140.164,11.555 C134.483,11.555 130.55,15.281 130.55,20.64 C130.55,25.309 133.816,28.345 138.807,28.345 C143.568,28.345 146.443,25.378 147.179,20.134 L147.386,18.685 L139.336,18.685 Z M147.955,28 L151.52,28 L153.452,17.857 L153.475,17.857 L159.202,28 L162.238,28 L165.366,11.9 L161.801,11.9 L159.869,22.089 L159.846,22.089 L154.096,11.9 L151.083,11.9 L147.955,28 Z" id="SIGN" fill="#333B40" />
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
    <div className="pt-10">
      <FormattedMessage id="content_provider__step_3_description" />
    </div>
  </div>
]


function ContentProviderEntry({ nextStep }: any) {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const detectMobile = useIsMobile();

  return (
    <>
      <h2 className="text-lg text-primary">
        <FormattedMessage id="content_provider__entry_title" />
      </h2>
      <p>
        <FormattedMessage id="content_provider__entry_description" />
      </p>
      {detectMobile.isMobile ? <ReactSimplyCarousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        preventScrollOnSwipe
        itemsToShow={1}
        itemsToScroll={1}
        backwardBtnProps={
          { show: false }
        }
        forwardBtnProps={
          { show: false }
        }
        dotsNav={{
          show: true,
          itemBtnProps: {
            className: "rounded-full bg-white h-3 w-3",
          },
          activeItemBtnProps: {
            className: "rounded-full bg-primary h-3 w-3",
          },
          containerProps: {
            className: "flex gap-2 mt-4",
          }
        }}
      >
        {inside}
      </ReactSimplyCarousel>
        :
        <div className="grid grid-cols-3 gap-4">
          {inside}
        </div>
      }
      <Button
        onClick={() => {
          nextStep();
        }}
        color="primary"
        className={"flex items-center justify-center gap-4 !px-10 !py-3"}
      >
        <FormattedMessage id="content_provider__start_process" />
        <FontAwesomeIcon icon={faArrowRight} />
      </Button>
      <div
        onClick={() =>
          window.open(
            `https://www.snapdesk.info/hc/${LOCALE.locale === "fr" ? "fr-fr" : "en-us"}/articles/4406628307474-A-quoi-sert-l-authentification-pour-publier-du-contenu-SEXY-ou-EXPLICITE-`,
            "_blank",
          )
        }
        className="flex cursor-pointer items-center justify-center gap-2"
      >
        <FontAwesomeIcon icon={faInfoCircle} />
        <FormattedMessage id="content_provider__more_infos" />
      </div>
    </>
  );
}

export default ContentProviderEntry;
